import Swiper, {Autoplay, Navigation, Pagination} from 'swiper'
import 'swiper/css/bundle'
import 'swiper/css/navigation';

class SimpleImageSlider {

  constructor(selector) {
    this.selector = selector;
  }

  init() {
    const swiper = new Swiper(this.selector,
      {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 100,
        initialSlide: 0,
        speed: 500,
        grabCursor: true,
        freeMode: false,
        setWrapperSize: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
      });
  }
}


export { SimpleImageSlider as default };
